import React, {useEffect, useRef, useState} from 'react';
import ReactDataGrid from 'react-data-grid';

import './DataGrid.scss'
import 'react-data-grid/lib/styles.css';
import { Tooltip } from 'react-tooltip';

const DataGrid = props =>{

  const {
    cols,
    rows,
    size = 'md',
    onCellClick = (e) => {},
    onCellDoubleClick = (e) => {},
    rowHeight = 48,
    headerRowHeight = 48,
    sortable= false,
    isNodataView = true,
    tooltip = false,
    overflowX="hidden"
  } = props;

  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [rowData, setRowData] = useState(rows);

  const addClassToColumns = (columns) => {

    const getRenderCell = (col) => {
      if (col.renderCell) return col.renderCell;

      return ({ row, rowIdx }) => {
        const value = row[col.key] ?? '-';
        const tooltipId = `${col.key}_${rowIdx}`;
        const shouldShowTooltip = tooltip || col.tooltip;

        const setTooltipIfOverflow = (el) => {
          if (el && el.scrollWidth > el.clientWidth) {
            el.setAttribute('data-tooltip-id', tooltipId);
            el.setAttribute('data-tooltip-content', value);
          }
        };

        return (
          <>
            {shouldShowTooltip && <Tooltip id={tooltipId} place="top" effect="solid" />}
            <div className="cell-text"
              ref={shouldShowTooltip ? setTooltipIfOverflow : null}
            >
              {value}
            </div>
          </>
        );
      };
    };

    return columns.map((col) => {
      const updatedColumn = {
        ...col,
        headerCellClass: col.headerCellClass||'' + ' custom_header_cel_' + size,
        cellClass: `${col.cellClass||''} custom_body_cel_${size} ${col.renderCell?' no-padding':''}`,
        sortable: ((col.sortable === undefined && sortable) || col.sortable === 'true' ? 'true' : ''),
        renderCell: getRenderCell(col),
      };

      // children 컬럼이 있을 경우, 재귀호출함.
      if (col.children) {
        updatedColumn.children = addClassToColumns(col.children);
      }
      return updatedColumn;
    });
  };

  const colData = addClassToColumns(cols);


  useEffect(() => {
    if (rows) { // rows 값에 따른 재 호출 구성
      setRowData(rows);
      setSortColumns(null); // 정렬 값 초기화
      setSelectedRowIndex(null); // 선택 인덱스 값을 초기화
    }
  }, [rows]);

  // 빈 테이블 "Nodata" 표현
  function EmptyRowsRenderer() {
    return (
      <div className={'noData'}>
        조회된 결과가 없습니다.
      </div>
    );
  }

  // 셀 윈 클릭
  const handleRowClick = (e) =>{
    const clickedRow = e.row; // 클릭된 셀의 행 데이터
    const rowIndex = rows.findIndex(row => row === clickedRow);
    setSelectedRowIndex(rowIndex);

    if(onCellClick !== null && onCellClick !== undefined){
      //onCellClick(clickedRow,e.column.renderCell.name);
      onCellClick(e);
    }
  };

  //row class 설정
  const getRowClassName = (row,rowIdx) => {
    const isSelected = selectedRowIndex === rowIdx;
    const isClickRow = 'onCellClick' in props || 'onCellDoubleClick' in props;

    let res = [];
      res.push(rowIdx % 2 === 0 ? "evenRow": "oddRow")
      isSelected && res.push( "selectedRow")
      isClickRow && res.push("pointerRow")
    return res.join(" ");
  };

  // 셀 더블 클릭
  const handleDoubleClick_DataGrid_row = (e) => {
    if(onCellDoubleClick !== null && onCellDoubleClick !== undefined) {
      onCellDoubleClick(e);
    }
  };

  // 컬럼 정렬
  const [sortColumns, setSortColumns] = useState([]);

  const handleSortColumnsChange = (sortColumns) => {
    setSortColumns(sortColumns);

    // 정렬된 열을 기준으로 데이터 정렬
    let sortedRows = [...rows];

    sortColumns.forEach((sortColumn) => {
      sortedRows = sortedRows.sort((a, b) => {
        const aValue = a[sortColumn.columnKey];
        const bValue = b[sortColumn.columnKey];

        // 숫자인 경우 정렬
        const isNumberA = !isNaN(aValue) && aValue !== null;
        const isNumberB = !isNaN(bValue) && bValue !== null;

        if (isNumberA && isNumberB) {
          return sortColumn.direction === 'ASC' ? aValue - bValue : bValue - aValue;
        }else{
          if (aValue < bValue) return sortColumn.direction === 'ASC' ? -1 : 1;
          if (aValue > bValue) return sortColumn.direction === 'ASC' ? 1 : -1;
          return 0;
        }
      });
    });
    //리턴 값이 0 경우 기존에 조회 된 값으로 셋팅이 필요함

    // 정렬된 데이터를 업데이트
    setRowData(sortedRows);
  };

  /* = 창 사이즈 버그에 따른 처리 ===== */
  const gridRef = useRef(null); // 부모 컨테이너 참조
  const [gridHeight, setGridHeight] = useState(400); // 기본 높이

  const [overHeight, setOverHeight] = useState(false);

  // // 부모 div의 높이를 계산하여 적용
  // useEffect(() => {
  //     const getDepth = (columns) => 1 + Math.max(0, ...columns.map(col => col.children ? getDepth(col.children) : 0));
  //
  //
  //     if (gridRef.current) {
  //         const updateHeight = () => {
  //             const parentHeight = gridRef.current.clientHeight; // 부모 div 높이 가져오기
  //             const totalRowHeight = rows.length * rowHeight + (headerRowHeight*getDepth(colData)) ;
  //
  //             setOverHeight(totalRowHeight > parentHeight);
  //             setGridHeight(totalRowHeight > parentHeight? parentHeight - 10 :  totalRowHeight+10  ); // 부모 높이와 행 개수를 고려하여 조정
  //         };
  //
  //         updateHeight();
  //         window.addEventListener("resize", updateHeight); // 창 크기 변경 시 높이 재계산
  //
  //         return () => window.removeEventListener("resize", updateHeight);
  //     }
  // }, [rows, rowHeight, headerRowHeight]);


  // 부모 div의 높이를 계산하여 적용
  useEffect(() => {
    if (gridRef.current) {
      const updateHeight = () => {
        const parentHeight = gridRef.current.clientHeight; // 부모 div 높이 가져오기
        setOverHeight(parentHeight);
      };

      updateHeight();
      window.addEventListener("resize", updateHeight); // 창 크기 변경 시 높이 재계산

      return () => window.removeEventListener("resize", updateHeight);
    }
  }, [rows, rowHeight, headerRowHeight]);

  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (gridRef.current) {
      const rect = gridRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top + window.scrollY,  // 스크롤 포함 좌표
        left: rect.left + window.scrollX,
        bottom : rect.bottom+ window.scrollY
      });

      // const height = rect.height;
      // console.log(height);
      // console.log("시작 좌표 : ", rect.top + window.scrollY);
      // console.log("바닥 좌표 : ", rect.bottom + window.scrollY);
      // console.log("높이 : ", rect.bottom + window.scrollY- rect.top + window.scrollY);
      // const scrollHeight = gridRef.current.clientHeight;
      // console.log("실제 높이 : ",scrollHeight)
      // const distanceFromWindowBottom = window.innerHeight - rect.bottom;
      // console.log("바닥에서 좌표 : ",distanceFromWindowBottom)
    }
  }, []);

  return(
    <div
      style={{
        display: 'flex',
        height : '100%',
        /*height: `calc(100vh - ${position.top}px)`,*/
        maxHeight: `calc(100vh - ${position.top+10}px)`,
        width: '100%',
        overflow: 'hidden',
        flex: 1
      }}
      ref={gridRef}
    >
      <ReactDataGrid
        style={{
          blockSize: 'calc(100% - 10px)',  // 내부적으로 높이를 100%로 설정
          width: '100%',
          overflowY: 'auto', // 내부에서 스크롤을 처리하도록 설정
          //overflowX:"hidden",
          overflowX:overflowX,
          backgroundColor: "#FFFFFF"
        }}
        className="rdg-light"
        columns={colData}
        rows={rowData}
        rowHeight={rowHeight}
        headerRowHeight={headerRowHeight}
        sortColumns={sortColumns}
        rowClass={getRowClassName}
        onCellClick = {handleRowClick}
        onCellDoubleClick={handleDoubleClick_DataGrid_row}
        onSortColumnsChange={handleSortColumnsChange}

        renderers={{ noRowsFallback: isNodataView? <EmptyRowsRenderer />:null }}
      />
    </div>
  );
};

export default DataGrid;
